import React from 'react';
import { Box } from '@mui/material';
import Hero from '../Landing/Hero';
import FAQSection from './FAQSection';
import { faqData } from './faq-content';
import FourthSection from './FourthSection';
import TopNav from '../../V2/TopNav-Bar/TopNav';
import Footer from '../../V2/Footer/Footer';

const MainSection = () => {
	return (
		<Box>
            <TopNav />
			<Hero
				title={
					<>
						Frequently Asked
						<br />
						Questions
					</>
				}
				description="Find clear answers to the most common questions."
			/>
			<FAQSection data={faqData} />
			<FourthSection />
            <Footer />
		</Box>
	);
};

export default MainSection;
